var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalEditionRol",
      attrs: { title: "Elimininar Rol", "hide-footer": "", centered: "" }
    },
    [
      _c("b-overlay", { attrs: { show: _vm.isSaving } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm._v(" Escriba el nombre del rol: "),
            _c("code", [_vm._v(_vm._s(_vm.rol.name))])
          ]),
          _c("div", { staticClass: "col-md-12 mt-2" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.confirmation,
                    expression: "confirmation"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "nombre",
                  placeholder: "Nombre del rol"
                },
                domProps: { value: _vm.confirmation },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.confirmation = $event.target.value
                  }
                }
              })
            ])
          ]),
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { disabled: _vm.rol.name !== _vm.confirmation },
                on: { click: _vm.deleteRol }
              },
              [_vm._v(" Eliminar ")]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }